(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ka-bridal-gallery"] && !Shopify.designMode) return;
  try {
    
function initializeBridalFilms(root = document) {
  root.querySelectorAll('.ka-bridal-film').forEach((player) => {
    if (player.dataset.backdropReady) return;
    const foreground = player.querySelector('.ka-bridal-film-video');
    const background = player.querySelector('.ka-bridal-film-background');
    if (!foreground || !background) return;
    player.dataset.backdropReady = 'true';
    const fitFrame = () => {
      if (!foreground.videoWidth || !foreground.videoHeight) return;
      const aspect = foreground.videoWidth / foreground.videoHeight;
      const width = Math.min(player.clientWidth, player.clientHeight * aspect);
      foreground.style.width = width + 'px';
      foreground.style.marginInline = 'auto';
    };
    foreground.addEventListener('loadedmetadata', fitFrame);
    const observer = new ResizeObserver(fitFrame);
    observer.observe(player);
    fitFrame();
    const syncTime = () => {
      if (background.readyState > 0 && Math.abs(background.currentTime - foreground.currentTime) > 0.3) {
        background.currentTime = foreground.currentTime;
      }
    };
    const syncPlayback = () => {
      syncTime();
      background.playbackRate = foreground.playbackRate;
      if (foreground.paused) background.pause();
      else background.play().catch(() => {});
    };
    ['play', 'pause', 'seeking', 'seeked', 'ratechange'].forEach((event) => foreground.addEventListener(event, syncPlayback));
    foreground.addEventListener('timeupdate', syncTime);
    background.addEventListener('loadedmetadata', syncPlayback);
    syncPlayback();
  });
}
initializeBridalFilms();
document.addEventListener('shopify:section:load', (event) => initializeBridalFilms(event.target));

if (!customElements.get('ka-gown-gallery')) {
  customElements.define('ka-gown-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryReady) return;
      this.galleryReady = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gown-view]');
        if (!button || !this.contains(button)) return;
        const image = this.querySelector('.ka-gown-main-image');
        if (!image) return;
        image.srcset = button.dataset.srcset;
        image.src = button.dataset.src;
        image.alt = button.dataset.alt;
        image.width = Number(button.dataset.width);
        image.height = Number(button.dataset.height);
        this.querySelectorAll('[data-gown-zoom]').forEach((link) => {
          link.href = button.dataset.zoom;
        });
        this.querySelectorAll('[data-gown-view]').forEach((view) => {
          view.setAttribute('aria-pressed', String(view === button));
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-header"] && !Shopify.designMode) return;
  try {
    
function kaSetup(root=document){
 root.querySelectorAll('video').forEach(video=>{
  if(video.dataset.autoplayBound)return;
  video.dataset.autoplayBound='true';
  const nativeControls=video.controls&&!video.closest('[data-video-autoplay]');
  video.muted=true;
  video.defaultMuted=true;
  video.autoplay=true;
  video.loop=true;
  video.playsInline=true;
  video.setAttribute('muted','');
  video.setAttribute('playsinline','');
  video.controls=nativeControls;
  let pending=true;
  let starting=false;
  const start=()=>{
   if(!pending||starting||document.hidden)return;
   starting=true;
   const playback=video.play();
   if(playback&&typeof playback.then==='function'){
    playback.then(()=>{pending=false;video.controls=nativeControls;}).catch(()=>{video.controls=true;}).finally(()=>{starting=false;});
   }else{starting=false;}
  };
  const started=()=>{pending=false;video.controls=nativeControls;};
  const retry=()=>{if(video.isConnected)start();};
  video.addEventListener('playing',started,{once:true});
  video.addEventListener('canplay',retry);
  document.addEventListener('visibilitychange',retry);
  window.addEventListener('pageshow',retry);
  document.addEventListener('pointerup',retry,{once:true,passive:true});
  document.addEventListener('keydown',retry,{once:true});
  start();
 });
 root.querySelectorAll('[data-filter-group]').forEach(group=>{if(group.dataset.bound)return;group.dataset.bound='true';group.querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>{const category=button.dataset.category;group.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));const section=group.closest('[data-catalog]');let count=0;section.querySelectorAll('[data-piece-category]').forEach(item=>{item.hidden=category!=='all'&&item.dataset.pieceCategory!==category;if(!item.hidden)count++;});section.querySelector('[data-piece-count]').textContent=count;}));});
 root.querySelectorAll('[data-waitlist]').forEach(form=>{
  if(form.dataset.bound)return;
  form.dataset.bound='true';
  form.addEventListener('submit',()=>{
   const field=form.querySelector('[name="contact[tags]"]');
   if(!field)return;
   // Start from the tags Liquid rendered (list + source tags), never a hardcoded copy.
   const tags=(field.defaultValue||'').split(',').map(tag=>tag.trim()).filter(Boolean);
   form.querySelectorAll('[data-interest]').forEach(f=>{if(f.value.trim())tags.push('ka-'+f.dataset.interest+':'+f.value.trim().replace(/,/g,' '));});
   field.value=tags.join(',');
  });
 });
 root.querySelectorAll('[data-ka-popup]').forEach(dialog=>{
  if(dialog.dataset.bound)return;
  dialog.dataset.bound='true';
  const KEY='kaLaunchPopup';
  const read=()=>{try{return localStorage.getItem(KEY);}catch(e){return null;}};
  const store=value=>{try{localStorage.setItem(KEY,value);}catch(e){}};
  const success=dialog.querySelector('.form-success');
  const open=()=>{
   if(dialog.open)return;
   if(typeof dialog.showModal==='function'){dialog.showModal();}else{dialog.setAttribute('open','');}
   document.documentElement.style.overflow='hidden';
   const field=dialog.querySelector('input[type=email]');
   if(field&&!success)setTimeout(()=>field.focus(),90);
  };
  const close=reason=>{
   store(reason);
   document.documentElement.style.overflow='';
   if(dialog.open&&typeof dialog.close==='function'){dialog.close();}else{dialog.removeAttribute('open');}
  };
  dialog.querySelectorAll('[data-popup-close]').forEach(button=>button.addEventListener('click',()=>close('dismissed')));
  dialog.addEventListener('cancel',event=>{event.preventDefault();close('dismissed');});
  dialog.addEventListener('click',event=>{if(event.target===dialog)close('dismissed');});
  const form=dialog.querySelector('form');
  if(form)form.addEventListener('submit',()=>store('pending'));
  const state=read();
  // 'pending' means this popup submitted just before the reload: confirm once, then retire it.
  if(state==='pending'){if(success){open();store('done');}else{store('done');}return;}
  if(state)return;
  // Signed up through any other form on the page: never nag.
  if(success){store('done');return;}
  const delay=(parseFloat(dialog.dataset.popupDelay)||6)*1000;
  setTimeout(open,delay);
 });
 root.querySelectorAll('[data-variant-select]').forEach(select=>{if(select.dataset.bound)return;select.dataset.bound='true';select.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('variant',select.value);location.assign(url.toString());});});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>kaSetup(),{once:true});}else{kaSetup();}document.addEventListener('shopify:section:load',()=>kaSetup());document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.mobile-nav[open]').forEach(el=>el.removeAttribute('open'));});

  } catch(e) { console.error(e); }
})();
})();
